<app-mainmenu
              title="{{ getTitel() }}"
              [back]="true"
              backUrl="#"
              [menuButtonVisible]="menuButtonVisible"
              (showMenu)="onShowMenu($event)"
              *ngIf="!auftragdetails.anzeigeBild" #mainmenu></app-mainmenu>

<ion-content *ngIf="geladen && darstellung === 'standard'" #content class="section-content" [class.schreibgeschuetzt]="auftragdetails.isReadOnly">
  <app-auftragdetails-standard [auftragdetails]="auftragdetails"></app-auftragdetails-standard>
</ion-content>

<ion-content *ngIf="geladen && darstellung === 'kommissionierung'" #content class="section-content">
  <app-auftragdetails-kommissionierung [auftragdetails]="auftragdetails"></app-auftragdetails-kommissionierung>
</ion-content>

<ion-content *ngIf="geladen && darstellung === 'beladung'" #content class="section-content">
  <app-auftragdetails-beladung [auftragdetails]="auftragdetails"></app-auftragdetails-beladung>
</ion-content>

<ion-content *ngIf="geladen && darstellung === 'wizard'" #content class="section-content-white">
  <app-auftragdetails-wizard [auftragdetails]="auftragdetails"></app-auftragdetails-wizard>
</ion-content>

<ion-content *ngIf="geladen && darstellung === 'wareneingang'" #content class="section-content">
  <app-auftragdetails-wareneingang [auftragdetails]="auftragdetails"></app-auftragdetails-wareneingang>
</ion-content>

<ion-footer *ngIf="geladen && auftrag && darstellung !== 'wizard' && app.AuftragFooterAnzeigen | async">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button appClick (clicked)="auftragdetails.onStatusmeldung()">Statusmeldung</ion-button>
    </ion-buttons>

    <ion-buttons slot="primary">
      <ion-button appClick (clicked)="auftragdetails.starteNavigation(auftrag.Abholadresse)" *ngIf="navigation">
        <ion-icon slot="icon-only" name="navigate"></ion-icon>
      </ion-button>
      <ion-button appClick (clicked)="onFotoAufnehmen()" *ngIf="!auftragdetails?.istAuftragAbgeschlossen">
        <ion-icon slot="icon-only" name="camera"></ion-icon>
      </ion-button>
      <ion-button appClick (clicked)="onOptionenAnzeigen()">
        <ion-icon slot="icon-only" name="ellipsis-vertical"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>